import React from "react";
import { useUtilityAdminTranslation } from "../../../../../hooks/useUtilityAdminTranslation";
import ConfirmationModal from "../../../../../common/components/xepp/confirmation-modal/ConfirmationModal";

interface RetryRefundModalProps {
	isOpen: boolean;
	isLoading: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

/** The "Retry Refund — This action cannot be undone" confirmation. */
const RetryRefundModal: React.FC<RetryRefundModalProps> = ({ isOpen, isLoading, onConfirm, onCancel }) => {
	const { t } = useUtilityAdminTranslation();

	return (
		<ConfirmationModal
			isOpen={isOpen}
			onClose={onCancel}
			onConfirm={onConfirm}
			title={t("refunds.retryModal.title")}
			description={t("refunds.retryModal.description")}
			message={t("refunds.retryModal.message")}
			cancelText={t("refunds.retryModal.no")}
			confirmText={t("refunds.retryModal.yes")}
			variant="info"
			isLoading={isLoading}
		/>
	);
};

export default RetryRefundModal;
